import * as net from 'util/Net';

import {
  AssayResultValidation,
  AssayRunValidation,
  AssayValidationComment,
  ValidatableInput,
  WritableAssayValidationStatus,
} from './ValidationConstants';

interface BulkSetAssayValidationResponse {
  assayRunValidationsByRunId: {[runId: string]: AssayRunValidation};
  assayResultValidationsByResultId: {[resultId: string]: AssayResultValidation};
}

export function bulkSetAssayValidation(
  validatableInputs: Array<ValidatableInput>,
  status: WritableAssayValidationStatus,
  comment: AssayValidationComment
): Promise<BulkSetAssayValidationResponse> {
  return net.postJSONPromise({
    url: '/1/api/results:bulk-set-assay-validation',
    data: {validatableInputs, status, comment},
  });
}
